import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { faFilter, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { InputComponent, CheckboxComponent, FaIconComponent } from '@akostm/orbit-ui';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'shared-conversation-list-search-bar',
  standalone: true,
  imports: [
    CommonModule,
    FaIconComponent,
    InputComponent,
    ReactiveFormsModule,
    CheckboxComponent,
    TranslatePipe,
  ],
  templateUrl: './conversation-list-search-bar.component.html',
  styleUrl: './conversation-list-search-bar.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationListSearchBarComponent {
  filterInputController = input.required<FormControl>();
  showArchivedController = input.required<FormControl>();

  showFilters = false;

  readonly searchIcon = faMagnifyingGlass;
  readonly filterIcon = faFilter;
}
